import React,{useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import './Memorizing.css'
import {Api, onPut, getPage, getPart, transMin, transMins} from '../Shared/Akademy'
//import useCached from '../Shared/CacheHook';

// Full screen ...
const MemorizeControl = ({role, version, page, onPrev, onNext, onPage, pages, onEtat, Message, expand=false}) => {

    const [loaded, Load] = useState(false)
    const [expanded, Expand] = useState(expand)
    const [play, Play] = useState(false)
    const [repeat, Repeat] = useState({i:0, n:1})
    const [speed, Speed] = useState(2)
    const [part, Part] = useState(-1) // for audio
    const [selected, Select] = useState(-1)  // for image
    const [clicked, Clicked] = useState({n:0,x:0,y:0,now:new Date()})
    const [moved, Moved] = useState({x:0,y:0})
    const [moving, Moving] = useState(-1)
    const [tilaawa, Tilaawa] = useState(null)
    const [title, Title] = useState("")
    const [items , Items] = useState([])
    const [all, All] = useState(false)
    const [touch, Touch] = useState({x:0,y:0})
    const [safha, Safha] = useState("")

    const istyle = {display: 'flex', justifyContent: 'center'}
    const tstyle = {position:'absolute', width: '10%', height: '5%', fontWeight:'bold', color:'darkred', filter: 'brightness(2)' , filter: 'saturate(1.1)'}

    //const { safhaCached, safhaLoading, safhaError } = useCached(safha)
    const audio = document.getElementById("tilaawa")

    useEffect(()=>{ 
        Load(false)   
        Play(false)
        Items([])
        Part(-1)    
        //alert(`page=${page} part=${part} expanded=${expanded}...`)
        if(page>0) {
            Safha(getPage(page, version))

            let request=`/waqafaat/${page}`
            if(version===2)
                request=`/waqafaat/hafs/${page}`

            //alert(`version=${version} request=${request}`)
            Api.get(request)
            .then(response => {
                Items(response?.data)
                Load(true)

            })
            .catch(error => {
                Message && Message(error)
            })
        }
    },[page])

    useEffect(()=>{
        //alert(`loaded=${loaded}...`)
        if(part<0 && items?.length>0) {
            const rect = document.getElementById("image").getBoundingClientRect()
            const pane = document.getElementById("ImagePane").getBoundingClientRect()
        
            transMins(items, rect, pane)
            .then(data=>{
                //console.log('data',data); alert(`length ${data.length} ${items.length}`)
                Items(data)
                Part(data.length)

                const item = items[0]
                //alert(JSON.stringify(item))
                Title(`صفحة:${page}  سورة:${item.Soora} حزب:${item.Hizb??''} ثمن:${item.Tomon??''} !`)                
            })            
        }
    },[items])

    useEffect(()=>{
        if(title!=="") {
            Message(title)
        }
        const element = document.getElementById("safahaat")
        if(element)
            element.title = title;

    },[title])  
    
    useEffect(()=>{
        if(page>0) {
            var sheader=document.getElementById("Header").style
            var simage=document.getElementById("image").style
            if(expanded){
                //var body = document.getElementById("MemorizingContainer")
                //if(body)
                //    body.style.maxHeight = "calc(100vh - 1.5rem)" // 2+1.5
                
                simage.maxHeight = "calc(100vh - 3.5rem)"
                sheader.height = "0rem"
                sheader.visibility="hidden"
            }
            else {
                simage.maxHeight = "calc((100vh - 8rem) - 20px)"
                sheader.visibility="visible"
                sheader.height = "4rem" 
            }
        }
    },[expanded]) 
    
    const onSpeed = e => {
        e.preventDefault()
        Speed(parseFloat(e.target.value))        
    }

    const onRepeat = e => {
        e.preventDefault()
        Repeat({i:0, n:parseInt(e.target.value)})
    }    

    const onTilaawa = (item) => {  
        if(item) {
            let p = items.findIndex(s=>s.Id===item.Id)
            //let sms=`selected:${selected} clicked:${p} Locked:${items[p].Locked}`; console.log(sms)//; alert(sms)

            if(p>=0) {
                items[p].Locked = (items[p].Locked>0)?0:1
    
                if(selected>=0) {
                    if(p>selected) {
                        if(items[p].Locked===items[selected].Locked) {
                            for(let i=selected+1; i<p; i++) {
                                items[i].Locked = items[selected].Locked
                            }
                        }
                        
                            for(let i=0; i<selected; i++) {
                                items[i].Locked = 0
                            }
                            for(let i=p+1; i<items.length; i++) {
                                items[i].Locked = 0
                            }
                        
                    }
                    else if(p<selected) {
                        if(items[p].Locked===items[selected].Locked) {
                            for(let i=p+1; i<selected; i++) {
                                items[i].Locked = items[selected].Locked
                            }
                        }
                        
                            for(let i=0; i<p; i++) {
                                items[i].Locked = 0
                            }
                            for(let i=selected+1; i<items.length; i++) {
                                items[i].Locked = 0
                            }
                        
                    }
                }
            }

            Select(p)

            if(play) {
                onPlay()
            }
        }
    }

    useEffect(()=>{
        if(speed>0 && audio) {
            audio.playbackRate=speed
            //alert(audio.playbackRate)
        }
    },[speed])

    useEffect(()=>{
        if(audio && play && tilaawa.endsWith('.mp3')) {
            audio.play()   
            audio.playbackRate=speed

            if(role>6) {
                onEtat(`speed=${speed} tilaawa=${tilaawa.slice(-17)}`)     
            }

        }
    },[tilaawa])

    useEffect(()=>{
        if(audio && play && part>=0 && part<items.length && repeat.i<repeat.n) {
            //alert(`useEffect repeat: ${repeat.i}/${repeat.n} - part: ${part}`)
            const file = getPart(items[part], version)//; alert(file)

            Tilaawa(file)
            
            if(file===tilaawa) {  // important for repeat ! 230122 
                audio.play() // Commented at 240218 but this solve an issue detected at 240314
                audio.playbackRate=speed
            }
        }
    },[part, repeat])
 
const Delay = ms => new Promise(res => setTimeout(res, ms))

async function onEnded() {
    //console.log('onEnded Repeat',repeat,part,items); alert(`onEnded ${play} ${repeat.i} ${repeat.n} ${part}`)

    if(play && repeat.i<repeat.n) 
    {
        for(let p=part+1; p<items.length; p++) {
            if(items[p].Locked>0) {
                await Delay(Math.trunc(900/speed))
                Part(p)
                return
            }
            else if(p+1===items.length) { // Added  at 240320 great caught  
                //alert(`delay ${repeat.i} - ${repeat.n}`)
                await Delay(Math.trunc(5000/speed))    
            }
        }
        
        Repeat({...repeat, i:repeat.i+1})

        if(repeat.i+1===repeat.n) {
            //alert(`delay ${repeat.i} - ${repeat.n}`)

            onPlay()
        }
        else {
            for(let p=0; p<items.length; p++) {
                if(items[p].Locked>0) {
                    Part(p)
                    return;
                }
            }
        }
    }
}         

const onPlay = () => {
    if(!play) {
        let locked=-1
        Repeat({...repeat, i:0})
        for(let p=0; p<items.length; p++) {
            if(items[p].Locked>0) {
                locked=p
                break
            }
        }
        
        if(locked<0 && items.length>0)
        {
            locked=0
            for(let p=0; p<items.length; p++)
                items[p].Locked=1

            All(true)
        }
        
        if(locked>=0)
        {
            Part(locked)
            audio.playbackRate=speed
            audio.style.visibility='visible'  
            Play(true)  
        }
    }
    else {
        audio.pause()
        audio.style.visibility='hidden'
        Play(false)
        if(all) {
            for(let p=0; p<items.length; p++)
                items[p].Locked=0

            All(false)
        }
    }
}

const onMouseDown = (item) => {
    if(role>6) {
        if(moving<0) {
            let p = items.findIndex(s=>s.Id===item.Id)
            Moving(p)        
            Moved({x:0, y:0})
        }
    }
}

const parseMin = (min) => {
    const rect = document.getElementById("image").getBoundingClientRect()
    const pane = document.getElementById("ImagePane").getBoundingClientRect()
    return transMin(min,rect,pane)
}

const onMove = (event) => {

    if(role>6 && moving>=0) {
        //let er = event.currentTarget.getBoundingClientRect()            
        let ir = document.getElementById("image").getBoundingClientRect()
        if(ir && ir.right>0 && ir.bottom>0) {
            //console.log("onMove event", event.clientX, event.clientY, "image", ir.left, ir.top); alert(role)
            let w=parseInt(ir.right-ir.left)
            let h=parseInt(ir.bottom-ir.top)

            let x = parseInt((event.clientX-ir.left+20)*100/w)||0
            let y = parseInt((event.clientY-ir.top-10)*100/h)||0
            let min = `${y},${100-x}`

            items[moving].Pos = parseMin(min)
            Moved({x,y})

            if(audio && role===9 && moving!==part) {
                Speed(4.0)
                
                const file = getPart(items[moving], version); 
                if(tilaawa!==file) {
                    Tilaawa(file)
                    //alert(`role=${role} file=${file}`)
                }
                else {
                    if(tilaawa.endsWith(".mp3")) {
                        audio.play()
                        audio.playbackRate=speed
                    }
                }
            }
        }
    }
}

const  onMouseUp = (event) => {
    if(role>6 && moving>=0) {

        Moving(-1)        
        
        if(moved.x>0 || moved.y>0) {
            let min = `${moved.y},${100-moved.x}`
            onPut(version, items[moving].Id, "Min", min)
            items[moving].Pos = parseMin(min)

            if(audio && role===9 && moving!==part) {
                audio.pause()
                /* Debug
                for(let p=moving+1; p<items.length; p++) {
                    let min = items[p].Min ?? ''
                    //alert(items[p].Min)
                    if(min==="") {
                        //alert(`${moving} / ${items.length}`)
                    }
                }
                */
            }
        }
    }
}


const onClick = (event) => {
    if(role<6) {
        //console.log("unauthorized")
        return
    }
            
    let cr = event.currentTarget.getBoundingClientRect()
    if(cr && cr.right>0 && cr.bottom>0) {
        let w=parseInt(cr.right-cr.left)
        let h=parseInt(cr.bottom-cr.top)
    
        let n = clicked.n
        let x = parseInt((event.clientX-cr.left)*100/w)||0
        let y = parseInt((event.clientY-cr.top)*100/h)||0
        let now = new Date()

        if(Math.abs(clicked.x-x)<3 && Math.abs(clicked.y-y)<3) {
            let ms=now.getTime()-clicked.now.getTime()
            if(ms<500) {
                n=n+1

                if(n>0 && selected>=0) {  // 2 or 3 click !
                    //Fetch clicked
                    let min = `${clicked.y},${100-clicked.x}`
                    onPut(version, items[selected].Id, "Min", min)

                    items[selected].Pos = parseMin(min)
                }
            }
            else
                n=0
        }
        else
            n=0
            
        Clicked({n,x,y,now})  
        }
    }

    const onTouchStart = (event) => {
        //console.log("onTouchStart", event); //alert("onTouchStart")
        let ts = event.targetTouches[0] // react
        Touch({x: ts.clientX, y:ts.clientY})
    }

    const onTouchEnd  = (event) => {
        let te = event.changedTouches[0] // react
        //alert(`onTouchEnd X e ${te.clientX} s ${touch.x} / Y e ${te.clientY} s ${touch.y} ?`)
        if(te.clientX>touch.x+50)
            onNext()
        else if(te.clientX<touch.x-50)
            onPrev()
    }

    const onSafha = (e) => {
        let value=parseInt(e?.target.value)
        onPage(value)
    }

    const sor3a = "سرعة"
    const tikraar = "تكرار" 

    const Safahaat = React.memo(({ options, value, onChange }) => (
        
        <select id="safahaat" style={{ ...tstyle, top:0, left:0, width:'5.5rem', height: '2rem', opacity:'0.6'}} 
            onChange={onChange} value={value} > 

        { options.length>0
            ? options.map((item, index) =>                  
                <option key={`Safha-${index}`} value={item.Safha}>{`${item.Safha} سورة ${item.Soora} صفخة`}</option>
            )
            : <option>No options available</option>
        }

        </select>
    ));

return (

safha.length>6 ? 
    <>
<div className="row" id="memorizeHeader">

<Safahaat options={pages} value={page} onChange={onSafha} />

<audio id="tilaawa" controls="controls" autobuffer="autobuffer"
onEnded={onEnded}
style={{position:'absolute', left:'20%', width:'60%', height:'2rem', top:0, visibility:'hidden', opacity:'0.8'}} 
src={tilaawa} />

    <div style={{ ...tstyle, top:'0', left:'25%', height: '2rem' }}>
                <p>{play?repeat.i+1:""} </p>
    </div>
    <Button className="mr-2" variant={play?"danger":"success"}  
            style={{ position:'absolute', left:'30%', width: '20%', height: '2rem', top:'0', opacity:'0.6' }}
                onClick={onPlay}
                ><i className={play?"fa fa-pause":"fa fa-play"} style={istyle}></i>
    </Button>
    <select id="repeats" title='التكرارات' style={{ ...tstyle, top:0, left:'55%', width:'4.5rem', height: '2rem', opacity:'0.6', zIndex:'60'}} 
        onChange={onRepeat} 
        defaultValue={repeat.n}
        >
        <option value='1'>1 {tikraar}</option><option value='2'>2 {tikraar}</option><option value='5'>5 {tikraar}</option><option value='7'>7 {tikraar}</option><option value='10'>10 {tikraar}</option>
    </select>

    <select id="speeds" title='السرعة' style={{ ...tstyle, top:0, left:'75%', width:'4.5rem', height: '2rem', opacity:'0.6'}} 
        onChange={onSpeed}
        defaultValue={speed}
        >
        <option value="1">1 {sor3a}</option>
        <option value="1.5">1.5 {sor3a}</option>
        <option value="2">2 {sor3a}</option>
        <option value="2.5">2.5 {sor3a}</option>
        <option value="3">3 {sor3a}</option>
        <option value="4">4 {sor3a}</option>
        <option value="5">5 {sor3a}</option>
    </select>
</div>

<div className="row page-center" id="memorizeBody">
        <div className="page-center" id="ImagePane">

        <img className="page-fit-center" alt="القرآن الكريم"  id="image" 
            src={safha} 
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            onClick={onClick}
        /> 

        <Button className="mr-2 NavButton" variant="warning" 
            style={{ left:0 }}
            onClick={()=>onNext()}
            ><i className="fa fa-arrow-left" style={istyle}></i>
        </Button>

        <Button className="mr-2 NavButton" variant="warning" 
            style={{ left:"94%" }}
            onClick={()=>onPrev()}
            ><i className="fa fa-arrow-right" style={istyle}></i>
        </Button>

        <Button className="mr-2 MButton" variant={"info"}  
            style={{ aspectRatio:'1 / 1', top:0, left:0, zIndex:777 }}
            onClick={()=>Expand(!expanded)}
            ><i className={"fa fa-expand"} style={istyle}></i>
        </Button>    

{ part>=0 && items?.length>0 && items.map((item, index) => (    
    <Button className='Part' variant={(item.Locked===1)?((play && index===part)?"danger":"success"):"primary"} key={item.Id} value={item.Id}
    style={{ ...item.Pos, borderColor:(selected===index)?'red':'gold'}}
        onClick={()=>onTilaawa(item)}
        onMouseDown={()=>onMouseDown(item)}
        onMouseMove={onMove}
        onMouseUp={onMouseUp}
        >{item.Aaya}</Button>
))}

        </div>
        </div>
    </>
    :
    <div id="Memorizing">  
        <div id="ImagePane" className="page-center">
            <audio id="tilaawa" />
            <img id="image" className="page-fit-center" alt="القرآن الكريم" /> 
        </div> 
    </div>
    )
}

export default MemorizeControl

